import QueryString from 'query-string';
import { FetchService } from '.';

export default class EventService extends FetchService {
  constructor() {
    super();

    this.get = this.get.bind(this);
    this.post = this.post.bind(this);
    this.delete = this.delete.bind(this);
  }

  get(query) {
    return this.Get('/events?' + QueryString.stringify(query), { cache: 'no-store' })
      .then((result) => {
        return Promise.resolve(result);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  post(venue_id, category, duration, date, bar_products, teams, goal) {
    return this.Post('/events', { body: JSON.stringify({ venue_id, category, duration, date, bar_products, teams, goal }) })
      .then((result) => {
        return Promise.resolve(result);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  delete(event_id) {
    return this.Post('/events/delete', { body: JSON.stringify({ event_id }) })
      .then((result) => {
        return Promise.resolve(result);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}
